import React, {useState, useRef, useEffect} from "react"
import axios from 'axios';

import {AppContext} from './Context';

import Form from "./Form";
import Spinner from "../../common-scripts/Helpers/Spinner";
import ModalComponent from "../../common-scripts/Helpers/ModalComponent";
import MessageSaveForm from "../../common-scripts/Helpers/MessageSaveForm";

// Form's initial datas
const initDatas = [
	{
		civility: "",
		firstName: "",
		lastName: "",
		birthName: "",
		birthDate: "",
		birthPlace: "",
		email: "",
		phone: "",
		numContrat: "",
		address: "",
		placeOf: "",
		postalCode: "",
		city: ""
	},
	{
		burialMode: {
			type: "",
			burialInfos: {
				nameCemetery: "",
				address: "",
				nameConcesionHolder: "",
				numConcession: "",
				relationshipWithConcessionHolder: "",
				placesRemaining: "",
				durationConcession: "",
				otherDuration: ""
			},
			cremationInfos: {
				destination: "",
				place: ""
			}
		},
		ceremony: "",
		otherDispositions: {
			floralComposition: {
				status: "",
				type: ""
			},
			typeOfCoffin: "",
			funeralHomeStay: "",
			conservationCare: "",
			pressNotices: "",
			announcement: "",
			announcementText: "",
			otherDispositions: ""
		},
		authorizeFuneralOrganization: false,
		authorizeSensitiveData: false
	},
	{
		mandator: {
			type: "",
			procheInfos: {
				civility: "",
				firstName: "",
				lastName: "",
				birthName: "",
				birthDate: "",
				email: "",
				phone: "",
				address: "",
				placeOf: "",
				postalCode: "",
				city: ""
			}
		},
		designPerson: "",
		personsToPrevent: []
	},
	{
		generalConditions: false
	},
	{
		summary: true
	},
	{
		cardType: '',
		cardVerso: '',
		cardRecto: ''
	}
];

/**
 * Return a message to show if GDV Exists
 *
 * @param {function} onBackHome Callback to fire on Cta click
 * @returns {JSX.Element}
 * @constructor
 */
const MessageGdvExist = ({onBackHome}) => {
	const message = `
  <p> Un formulaire de recueil des volontés en votre nom existe déjà. </p>
  <p> Vous pourrez continuer de renseigner vos volontés en cliquant sur le lien du mail que vous allez recevoir. </p>

  <p>Nous vous remercions de votre confiance et restons à votre disposition.</p> `;


	return <>
		<div style={{textAlign: 'center'}} dangerouslySetInnerHTML={{__html: message}} className="card-body"></div>
		<div className="bottom">
			<div className="prev_next stepper">
				<div id="prev_mobile">
					<button onClick={onBackHome} style={{marginRight: '0px'}}
							className="bouton-picto-left goto_backto ">Revenir à l’accueil
					</button>

				</div>
			</div>
		</div>


	</>
}


const App = ({stepInfo, homeUrl, referencesUrl, identifier, docusignStatus, popupCta, assistanceTexts, conditionPdfUrl}) => {
	const baseURL = homeUrl;
	const referencesUrls = JSON.parse(referencesUrl);
	const popupCtaInfos = JSON.parse(popupCta);

	const textsAssistance = JSON.parse(assistanceTexts);

	// general condition pdf url
	const gcPdfUrl = JSON.parse(conditionPdfUrl);


	// States declaration Start
	const [userIdentifier, setUserIdentifier] = useState(identifier ? identifier : null);
	const [showloader, setShowloader] = useState(false);
	const [showMessageSaveForm, setShowMessageSaveForm] = useState(false);
	const [showMessageGdvExist, setShowMessageGdvExist] = useState(false);
	const [showIframe, setShowIframe] = useState(false);
	const [iframeurl, setIframeurl] = useState(null);

	const [currentStep, setCurrentStep] = useState(4);
	const [steps, setSteps] = useState(JSON.parse(stepInfo));
	const [userProgress, setuserProgress] = useState({
		number: (currentStep + 1) + "/7",
		pourcentage: Math.floor(((currentStep + 1) / 7) * 100)
	});
	const [datas, setdatas] = useState(initDatas);
	// States declaration End

	// Refs declaration starts
	const progressBarRef = useRef(null);
	// Refs declaration ends


	/**
	 * Synchronize Step Datas
	 *
	 * @param {number} stepindex - index of the step
	 */
	const syncStepData = (stepindex) => {

		setSteps(steps.map((step, index) => {
				if (index <= stepindex) {
					return {
						...step,
						is_ready_for_next: true,
						is_validate: index == stepindex ? false : true,
						is_ready_for_save: true,
						is_current: index == stepindex
					}
				} else
					return step;
			}
		));
	}

	/**
	 * Srcoll to the Top of screen
	 * @returns {*}
	 */
	const scrollToTop = () => progressBarRef.current.scrollIntoView({behavior: 'smooth'});

	/**
	 * Dispatch Step Event
	 *
	 * @param {string} actionType
	 * @param payload
	 */
	const dispatchStepEvent = (actionType, payload) => {

		switch (actionType) {
			case 'SET_STEP_READY':
				setStepReady(payload);
				break;
			case 'SET_STEP_READY_TOSAVE':
				setStepReadyToSave(payload);
				break;
			case 'NEXT_STEP':
				saveSubscriberForm(datas[0].email, "pending");
				break;
			case 'PREV_STEP':
				prevStep();
				break;
			case 'BACK_TO_HOME':
				backToHome();
				break;
			case 'SIGNER':
				sendEnvelop();
				break;
			case 'SAVE':
				saveSubscriberForm(payload, "saved");
				break;
			case 'SAVE_AFTER_DOCUSIGN':
				saveAfterDocusign(payload, "saved");
				break;
			case 'SYNC_STEP_DATA':
				syncStepData(payload);
				break;
			case 'DOWNLOAD':
				downlodaDoc();
				break;
			default:
				break;
		}
	};


	/**
	 * Back to the Home of App
	 */
	const backToHome = () => {

		window.location.href = homeUrl;

	}

	/**
	 * Save Subscriber Form if he chooses to sign later
	 *
	 * @param {string} email - The email filled in the form
	 * @param {string} status - Status of processus
	 */
	const saveAfterDocusign = (email, status) => {
		const _status = status;

		axios.post(baseURL + "/wp-json/gdv/v1/save", {
			step: 5,
			email: email,
			status: _status,
			identifier: userIdentifier,
			data: datas
		}, {
			headers: {
				"Content-Type": 'application/json',
				"Accept": "application/json"
			}
		}).then((response) => {

			if (userIdentifier == null) {
				setUserIdentifier(response.data.data.identifier);
			}

		}).catch((error) => {
			console.log(error);
		});
	}

	/**
	 * Save Subscriber Form
	 *
	 * @param {string} email - The email filled in the form
	 * @param {string} status - Status of processus
	 */
	const saveSubscriberForm = (email, status) => {
		const _status = status

		if (_status == "saved") {
			setShowloader(true);
		}
		axios.post(baseURL + "/wp-json/gdv/v1/save", {
			step: currentStep,
			email: email,
			status: _status,
			identifier: userIdentifier,
			data: datas
		}, {
			headers: {
				"Content-Type": 'application/json',
				"Accept": "application/json"
			}
		}).then((response) => {
			setShowloader(false);
			if (response.data.status == "gdv_exist") {
				setShowMessageGdvExist(true);
				return;
			}
			if (_status == "saved") {

				setuserProgress({
					number: (currentStep + 1) + "/7",
					pourcentage: Math.floor(((currentStep + 1) / 7) * 100)
				})
				setShowMessageSaveForm(true);

			}

			if (userIdentifier == null) {
				setUserIdentifier(response.data.data.identifier);
			}

			if (_status == "pending") {
				nextStep();
			}

		}).catch((error) => {
			setShowloader(false);

		});
	}

	/**
	 * Function called to download document generated
	 */
	const downlodaDoc = () => {
		setShowloader(true);
		axios.post(baseURL + "/wp-json/gdv/v1/download", {
			step: currentStep,
			email: datas[0].email,
			identifier: userIdentifier,
			data: datas
		}, {
			headers: {}
		}).then((response) => {
			setShowloader(false);
			let url = `data:application/pdf;base64,${response.data}`;
			let a = document.createElement('a');
			a.href = url;
			a.download = 'Gdv_electronique_' + datas[0].firstName + '_' + datas[0].lastName + '.pdf';
			a.click();


		}).catch((error) => {
			setShowloader(false);

		});
	}

	/**
	 * Funtion for going to the next step
	 */
	const nextStep = () => {
		if (currentStep < steps.length) {
			let nextStep = currentStep + 1;
			setSteps(steps.map((step, index) => {
					if (index == currentStep) {
						return {...step, is_current: !step.is_current, is_validate: true};
					} else if (index == nextStep) {
						return {...step, is_current: true};
					} else {
						return step;
					}
				}
			))
			setCurrentStep(nextStep);
		}
	}

	/**
	 * Function for returning to the previous step
	 */
	const prevStep = () => {
		if (currentStep > 0) {
			let prevStep = currentStep - 1;
			setSteps(steps.map((step, index) => {
					if (index == currentStep) {
						return {...step, is_current: false};
					} else if (index == prevStep) {
						return {...step, is_current: true, is_validate: false};
					} else {
						return step;
					}
				}
			))
			setCurrentStep(prevStep);
		}
	}


	/**
	 * Set state of the step ready
	 *
	 * @param state
	 */
	const setStepReady = (state) => {

		setSteps(steps.map((step, index) => {
				if (index == currentStep) {
					return {...step, is_ready_for_next: state}
				} else {
					return step;
				}
			}
		))

	}

	/**
	 * Set the state ready to save
	 *
	 * @param state
	 */
	const setStepReadyToSave = (state) => {
		setSteps(steps.map((step, index) => {
				if (index == currentStep) {
					return {...step, is_ready_for_save: state};
				} else {
					return step;
				}

			}
		))
	}

	/**
	 * Sending Enveloppe to Docusign
	 */
	const sendEnvelop = () => {
		setShowloader(true);
		axios.post(baseURL + "/wp-json/gdv/v1/signer", {
			data: datas,
			identifier: userIdentifier,
			email: datas[0].email, step: currentStep + 1
		}, {
			headers: {
				"Content-Type": 'application/json',
				"Accept": "application/json"

			}
		}).then((response) => {
			let data = response.data;
			if (data.redirect_mode == 'Yes') {
				window.location.href = data.embed_url;
			} else {

				setIframeurl(data.embed_url);
				setShowIframe(true);
				setShowloader(false);
			}

		}).catch((error) => {
			setShowloader(false);

		});
	}


	return (
		<React.Fragment>
			<AppContext.Provider value={{
				currentStep,
				setCurrentStep,
				steps,
				setSteps,
				dispatchStepEvent,
				datas,
				setdatas,
				iframeurl,
				setShowloader,
				showloader,
				setIframeurl,
				scrollToTop,
				referencesUrls,
				docusignStatus,
				setUserIdentifier,
				popupCtaInfos,
				textsAssistance,
				gcPdfUrl
			}}>

				<Form homeUrl={homeUrl} progressBarRef={progressBarRef} identifier={identifier}/>
				{showloader && <Spinner/>}
				{showMessageSaveForm && <ModalComponent showModal={true}
														content={<MessageSaveForm onBackHome={backToHome}
																				  progresStep={userProgress}/>}/>}
				{showMessageGdvExist && <ModalComponent showModal={true}
														content={<MessageGdvExist onBackHome={backToHome}
																				  progresStep={userProgress}/>}/>}

				<div className={`form-modal ${showIframe ? "show-modal" : ""}`}>
					<div className="modal">
						<div className="modal-content">
							<iframe
								title="docusign"
								src={iframeurl}
								height="720"
								width="1280"
								frameBorder="0"
								scrolling="no"
								allowFullScreen={true}

							></iframe>

						</div>

					</div>

				</div>

			</AppContext.Provider>
		</React.Fragment>

	)
}

export default App;
